<template>
  <div class="goods_region_restrict">
    <div class="goods_region_restrict__title">
      无法配送区域
      <i class="icon close" @click="close"></i>
    </div>
    <ul id="content" class="goods_region_restrict__content">
      <li v-for="(item, index) in list" :key="index" class="goods_region_restrict__content-item" nowrap>
        <p class="goods_region_restrict__content-title"> {{ item }}</p>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: ['list'],
  data() {
    return {};
  },
  created() {
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.goods_region_restrict {

  position: relative;
  padding: 90px 30px 30px 30px;
  width: 100%;
  box-sizing: border-box;

  &__title {
    font-size: 30px;
    color: #4a4a4a;
    font-weight: 500;
    text-align: center;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 9px;
    line-height: 90px;
    background: #fff;

    i {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }

  &__content {
    overflow-y: scroll;

    &-item {

      & + & {
        margin-top: 30px;
      }
    }

    &-title {
      font-size: 26px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      color: #2d2d2d;

      &::before {
        content: '';
        display: block;
        width: 14px;
        height: 14px;
        background: rgba(255, 116, 35, 1);
        border-radius: 50%;
        margin-right: 19px;
      }
    }

    &-text {
      padding-left: 30px;
    }

    p {
      font-size: 24px;
      color: #7b7b7b;
    }
  }
}
</style>
